import React from "react";
import Tabs, { getTabsProps } from "components/Tabs";
import PublishLocation from "./PublishLocation";
import PublishEmbed from "./PublishEmbed";
import { APP_PUBLISH_TAB } from "utils/constants/application";

/**
 * ==========================
 * Publishing
 * ==========================
 * We want to publish the page to a specific route
 * We can set the target route via either
 * - Existing (dropdown)
 * - New (input)
 * The publish action triggers the FormerEditor > getAppManifestPublishParams
 * @param {Object} props
 * @param {Function} props.setShow
 * @param {Function} props.publish
 * @returns
 */
const PublishConfigForm = ({ setShow, publish }) => {
  const tabProps = {
    ...getTabsProps(),
    tabs: [
      {
        name: "Location",
        id: APP_PUBLISH_TAB.LOCATION,
        node: (
          <div className="ph3 pt3 mt2">
            <PublishLocation setShow={setShow} publish={publish} />
          </div>
        )
      }
    ]
  };

  tabProps.tabs.push({
    name: "Embed",
    id: APP_PUBLISH_TAB.EMBED,
    node: (
      <div className="ph3 pt3 mt2">
        <PublishEmbed />
      </div>
    )
  });

  return (
    <div className="w-100 h-100 h-auto-ns center pb3">
      <div className="ph3 w-100">
        <div className="f2 fw6 pv3">Publish</div>
        <div className="f5 pv2 w-100 lh-copy">
          Publish to a hosted location or embed within your own webpage.
        </div>
      </div>
      <div className={tabProps.tabs.length > 1 ? "pt3 pb2" : ""}>
        <Tabs {...tabProps} />
      </div>
    </div>
  );
};

export default PublishConfigForm;
